import React from "react";
import { IconButton, Tooltip } from "@chakra-ui/react";
import "../Layout/football-details.css";
import { FaPlus, FaEye, FaTrash, FaRegImage } from "react-icons/fa";

interface PlayerInfoInterface {
  photoUrl: string;
  isFile?: boolean;
  name: string;
  playerId: number;
  add: (playerId: number, namePlayer: string) => void;
  view: (playerId: number, seasonId: number, name: string) => void;
  seandonId: number;
  admin: boolean;
  remove?: (itemId: number) => void;
  iconRemove?: boolean;
}

export const PlayerInfo: React.FC<PlayerInfoInterface> = ({
  name,
  isFile = false,
  playerId,
  add,
  view,
  seandonId,
  admin = false,
  iconRemove = false,
  remove,
}) => {
  const words = name.trim().split(/\s+/);
  const initials = (words[0]?.charAt(0) + (words.length > 1 ? words[words.length - 1].charAt(0) : "")).toUpperCase();

  const navigationButtons = [
    {
      icon: FaPlus,
      label: "Registrar desempenho",
      action: () => add(playerId, name),
      visible: admin,
    },
    {
      icon: FaEye,
      label: isFile ? "Visualizar arquivo" : "Ver histórico",
      action: () => view(playerId, seandonId, name),
      visible: true,
    },
    {
      icon: FaTrash,
      label: "Remover",
      action: () => remove && remove(playerId),
      visible: iconRemove,
    },
  ];

  return (
    <article className="squad-card">
      <span className="squad-avatar" aria-hidden="true">{isFile ? <FaRegImage /> : initials}</span>
      <div className="squad-card__identity">
        <h2>{name}</h2>
        <span>{isFile ? "Arquivo da temporada" : "Jogador do elenco"}</span>
      </div>
      <div className="squad-actions">
        {navigationButtons.filter((button) => button.visible).map((button) => (
          <Tooltip key={button.label} label={button.label}>
            <IconButton
              className="squad-action"
              variant="unstyled"
              aria-label={`${button.label}: ${name}`}
              icon={<button.icon />}
              onClick={(e) => { e.stopPropagation(); button.action(); }}
            />
          </Tooltip>
        ))}
      </div>
    </article>
  );
};
